import Base from "@/api-services/base";
const BaseURL = `Nom035Stps2018`;

export default {
  GetsResponse: null,
  Listado: [],
  FotoURL(Registro) {
    return "/img/grupos.svg";
  },
  GetDashboard(
    Vista,
    Nom035Stps2018ID,
    BaseGetsListado,
    OnCorrecto,
    OnErroneo,
    OnFinalizado
  ) {
    var URL = `${BaseURL}/${Nom035Stps2018ID}/Dashboard`;
    return Base.getsBaseSuscripcion(
      Vista,
      URL,
      BaseGetsListado,
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  GetNom035Stps2018Evaluacion(
    Vista,
    Nom035Stps2018EvaluacionID,
    OnCorrecto,
    OnErroneo,
    OnFinalizado
  ) {
    var URL = `${BaseURL}/Evaluaciones/${Nom035Stps2018EvaluacionID}`;
    return Base.getsBaseSuscripcion(
      Vista,
      URL,
      {},
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  PutNom035Stps2018Evaluacion(
    Vista,
    Nom035Stps2018EvaluacionID,
    Datos,
    OnCorrecto,
    OnErroneo,
    OnFinalizado
  ) {
    var URL = `${BaseURL}/Evaluaciones/${Nom035Stps2018EvaluacionID}`;
    return Base.putBaseSuscripcion(
      Vista,
      URL,
      Datos,
      {},
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  GetsNom035Stps2018s(
    Vista,
    Nom035Stps2018ID,
    BaseGetsListado,
    OnCorrecto,
    OnErroneo,
    OnFinalizado
  ) {
    var URL = `${BaseURL}/${Nom035Stps2018ID}/Evaluaciones`;
    return Base.getsBaseSuscripcion(
      Vista,
      URL,
      BaseGetsListado,
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  /**
   * Dispersa el enlace del cuestionario por notificación dentro de la plataforma, por
   * correo electrónico o por ambos.
   *
   * Sólo alcanza a los colaboradores que el usuario ya ve en el listado. Con
   * `Datos.SoloContar` en verdadero no envía nada y únicamente devuelve el conteo de
   * destinatarios, que es lo que se muestra para confirmar antes de disparar.
   *
   * @param {Object} Datos - { Filtro, Estados, ColaboradoresIDs, PorNotificacion,
   *   PorCorreo, SoloContar }. PorNotificacion es el envío dentro de la app y
   *   PorCorreo el que va al correo registrado en eClock; se pueden combinar, pero
   *   sin ninguno de los dos la API responde 400.
   */
  Notificar(
    Vista,
    Nom035Stps2018ID,
    Datos,
    OnCorrecto,
    OnErroneo,
    OnFinalizado
  ) {
    var URL = `${BaseURL}/${Nom035Stps2018ID}/Evaluaciones/Notificar`;
    return Base.postBaseSuscripcion(
      Vista,
      URL,
      Datos,
      {},
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  /**
   * Envía la notificación con el enlace a un solo colaborador.
   * Devuelve el mismo resumen que el envío masivo, con un solo renglón.
   */
  NotificarEvaluacion(
    Vista,
    Nom035Stps2018EvaluacionID,
    OnCorrecto,
    OnErroneo,
    OnFinalizado
  ) {
    var URL = `${BaseURL}/Evaluaciones/${Nom035Stps2018EvaluacionID}/Notificar`;
    return Base.postBaseSuscripcion(
      Vista,
      URL,
      {},
      {},
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  gets(Vista, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(
      Vista,
      BaseURL,
      BaseGetsListado,
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  getsSelect(Vista, OnCorrecto, OnErroneo, OnFinalizado) {
    if (this.GetsResponse != null) OnCorrecto(this.GetsResponse);
    return Base.getsBaseSuscripcion(
      Vista,
      BaseURL,
      { PaginaLen: 1000 },
      (response) => {
        this.GetsResponse = response;
        this.Listado = response.data.listado;
        if (OnCorrecto != undefined) OnCorrecto(response);
      },
      OnErroneo,
      OnFinalizado
    );
  },
  put(Vista, ID, Datos, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/${ID}`);
    return Base.put(Vista, URL, Datos, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
  post(Vista, Datos, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.postBaseSuscripcion(
      Vista,
      BaseURL,
      Datos,
      {},
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  get(Vista, id, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(
      Vista,
      `${BaseURL}/${id}`,
      {},
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  delete(Vista, id, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.deleteBaseSuscripcion(
      Vista,
      `${BaseURL}/${id}`,
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },

  excelEmpresa(Vista,id,BaseGetsListado,OnCorrecto,OnErroneo,OnFinalizado){
    let URL = Base.ObtenURLSuscripcion(`${BaseURL}/${id}/Excel/xEmpresa`);
    return Base.get(
      Vista,
     URL,
     { responseType: "blob",  params:{Empresas:BaseGetsListado} },
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    )
  },
  excelColaborador(Vista,id,BaseGetsListado,OnCorrecto,OnErroneo,OnFinalizado){
    let URL = Base.ObtenURLSuscripcion(`${BaseURL}/${id}/Excel/xColaborador`);
    return Base.get(
      Vista,
     URL,
     { responseType: "blob",  params:{Empresas:BaseGetsListado.empresas,Departamentos:BaseGetsListado.departamentos,Colaboradores:BaseGetsListado.colaboradores} },
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    )
   
  },
  excelDepartamento(Vista,id,BaseGetsListado,OnCorrecto,OnErroneo,OnFinalizado){
    let URL = Base.ObtenURLSuscripcion(`${BaseURL}/${id}/Excel/xDepartamento`);
    return Base.get(
      Vista,
     URL,
     { responseType: "blob",  params:{Empresas:BaseGetsListado.empresas,Departamentos:BaseGetsListado.departamentos} },
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    )
  },



  EstadoTipo(Estado) {
    switch (Estado) {
      case "NoIniciado":
        return "info";
      case "Enviado":
        return "warning";
      case "Visto":
      case "Iniciado":
        return "default";
    }
    return "success";
  },
  EstadoColor(Estado) {
    switch (Estado) {
      case "NoIniciado":
        return "1d8cf8";
      case "Enviado":
        return "#ff8d72";
      case "Visto":
      case "Iniciado":
        return "#344675";
    }
    return "#00bf9a";
  },
  EstadoEtiqueta(Estado) {
    switch (Estado) {
      case "NoIniciado":
        return "No iniciado";

      default:
        return Estado;
        break;
    }
  },
  Rango2Color(Rango) {
    switch (Rango) {
      case "Nulo":
        return "var(--default)";
      //return 'blue';
      case "Bajo":
        return "var(--green)";
      case "Medio":
        return "var(--yellow)";
      case "Alto":
        return "var(--orange)";
    }
    return "var(--red)";
  },
  Rango2Int(Rango) {
    if (Rango == null) return 0;
    if (Rango.calificacion != undefined) Rango = Rango.calificacion;
    switch (Rango) {
      case "Nulo":
        return 0;
      //return 'blue';
      case "Bajo":
        return 1;
      case "Medio":
        return 2;
      case "Alto":
        return 3;
    }
    return 4;
  },
  Int2Rango(Rango) {
    switch (Rango) {
      case 0:
        return "Nulo";
      //return 'blue';
      case 1:
        return "Bajo";
      case 2:
        return "Medio";
      case 3:
        return "Alto";
    }
    return "Muy alto";
  },
  /**
   * Indica si la evaluación ya tiene un resultado de riesgo calculado.
   *
   * Sin las guías II o III contestadas no hay riesgo que reportar. CalificacionTotal
   * regresa "Nulo" en ese caso, que se lee como "riesgo nulo" —el mejor resultado
   * posible— cuando en realidad el colaborador ni siquiera ha abierto su cuestionario.
   */
  TieneCalificacion(evaluacion) {
    if (evaluacion == undefined || evaluacion == null) return false;
    return (
      (evaluacion.griii != undefined && evaluacion.griii != null) ||
      (evaluacion.grii != undefined && evaluacion.grii != null)
    );
  },
  ///Obtiene la calificación de grii y griii
  CalificacionTotal(evaluacion) {
    if (evaluacion.griii != undefined && evaluacion.griii != null)
      return evaluacion.griii.calificacion;
    if (evaluacion.grii != undefined && evaluacion.grii != null)
      return evaluacion.grii.calificacion;
    return "Nulo";
  },
  ///Obtiene la propieda calificacion del objeto
  Calificacion(evaluacion) {
    if (evaluacion != undefined) return evaluacion.calificacion;
    return "Nulo";
  },
  AyudaEvaluacion(calificacion) {
    switch (calificacion) {
      case "Nulo":
        return "El riesgo resulta despreciable por lo que no se requiere medidas adicionales.";
      //return 'blue';
      case "Bajo":
        return "Es necesario una mayor difusión de la política de prevención de riesgos psicosociales y programas para: la prevención de los factores de riesgo psicosocial, la promoción de un entorno organizacional favorable y la prevención de la violencia laboral.";
      case "Medio":
        return "Se requiere revisar la política de prevención de riesgos psicosociales y programas para la prevención de los factores de riesgo psicosocial, la promoción de un entorno organizacional favorable y la prevención de la violencia laboral, así como reforzar su aplicación y difusión, mediante un Programa de intervención.";
      case "Alto":
        return "Se requiere realizar un análisis de cada categoría y dominio, de manera que se puedan determinar las acciones de intervención apropiadas a través de un Programa de intervención, que podrá incluir una evaluación específica1 y deberá incluir una campaña de sensibilización, revisar la política de prevención de riesgos psicosociales y programas para la prevención de los factores de riesgo psicosocial, la promoción de un entorno organizacional favorable y la prevención de la violencia laboral, así como reforzar su aplicación y difusión.";
      default:
        return "Se requiere realizar el análisis de cada categoría y dominio para establecer las acciones de intervención apropiadas, mediante un Programa de intervención que deberá incluir evaluaciones específicas1, y contemplar campañas de sensibilización, revisar la política de prevención de riesgos psicosociales y programas para la prevención de los factores de riesgo psicosocial, la promoción de un entorno organizacional favorable y la prevención de la violencia laboral, así como reforzar su aplicación y difusión.";
    }
    return "";
  },
  ObtenPropiedadNombre(Propiedad) {
    switch (Propiedad) {
      case "AmbienteDeTrabajo":
        return "Ambiente de trabajo";
      case "CondicionesEnElAmbienteDeTrabajo":
        return "Condiciones en el ambiente de trabajo";
      case "FactoresPropiosDeActividad":
        return "Factores propios de actividad";
      case "CargaDeTrabajo":
        return "Carga de trabajo";
      case "FaltaDeControlSobreElTrabajo":
        return "Falta de control sobre el trabajo";
      case "OrganizacionDelTiempoDeTrabajo":
        return "Organizacion del tiempo de trabajo";
      case "InterferenciaEnLaRelacionTrabajoFamilia":
        return "Interferencia en la relacion trabajo familia";
      case "JornadaDeTrabajo":
        return "Jornada de trabajo";
      case "LiderazgoyRelacionesEnElTrabajo":
        return "Liderazgo y relaciones en el trabajo";
      case "Liderazgo":
        return "Liderazgo";
      case "RelacionesEnElTrabajo":
        return "Relaciones en el trabajo";
      case "RelacionesSocialesEnElTrabajo":
        return "Relaciones sociales en el trabajo";
      case "OrganizacionDelTiempoDeTrabajo":
        return "Organizacion del tiempo de trabajo";
      case "InfluenciaDeLasResponsabilidadesFamiliares":
        return "Influencia de las responsabilidades familiares";
      case "InfluenciaDelTrabajoFueraDelCentroLaboral":
        return "Influencia del trabajo fuera del centro laboral";
      case "EntornoOrganizacional":
        return "Entorno organizacional";
      case "ReconocimientoDelDesempeno":
        return "Reconocimiento del desempeno";
      case "InsuficienteSentidoDePertenenciaeInestabilidad":
        return "Insuficiente sentido de pertenencia e inestabilidad";
    }
    return Propiedad;
  },
  ObtenCalificacionTotal(Agrupacion) {
    var Yo = this;
    let valores = Agrupacion.map(function (x) {
      return Yo.Rango2Int(Yo.CalificacionTotal(x.evaluacion.evaluacion));
    });
    let sum = valores.reduce((previous, current) => (current += previous));
    let avg = Math.ceil(sum / valores.length);
    return avg;
  },
  ObtenCalificacion(Agrupacion, Propiedad, Propiedad2) {
    var Yo = this;
    let valores = Agrupacion.map(function (x) {
      var EPropiedad = x.evaluacion.evaluacion[Propiedad];
      if (Propiedad2 != undefined) {
        if (EPropiedad == null) return Yo.Rango2Int(null);
        var EPropiedad2 = EPropiedad[Propiedad2];
        return Yo.Rango2Int(EPropiedad2);
      }
      return Yo.Rango2Int(EPropiedad);
    });
    let sum = valores.reduce((previous, current) => (current += previous));
    let avg = Math.ceil(sum / valores.length);
    return avg;
  },
  ObtenFiltrados(Agrupacion, Propiedad, Propiedad2, Filtro) {
    var Yo = this;
    let valores = Agrupacion.filter((x) => {
      if (Propiedad2 != undefined)
        return (
          Yo.Calificacion(x.evaluacion.evaluacion[Propiedad][Propiedad2]) ==
          Filtro
        );
      return Yo.Calificacion(x.evaluacion.evaluacion[Propiedad]) == Filtro;
    });
    return valores;
  },
};
